import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { getEnvelopData } from '@util/EnveleopDataManipulation'
import { type DashboardStateType, type DashboardResponseType } from '@app-types/DashboardTypes'

const initialState: DashboardStateType = {
    envelopsLoading: false,
    envelopsData: null,
    filteredEnevelopData: {
        count: 0,
        envelops: [],
    },
    enevelopsError: null,
    filterData: {
        completed: false,
        pendingOthers: false,
        pending: false,
        rejected: false,
    },
}

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        getEnvelops(state, action: PayloadAction) {
            state.envelopsLoading = true
            state.enevelopsError = null
        },
        getEnvelopsSuccess(state, action: PayloadAction<DashboardResponseType>) {
            const { recipients, count } = action.payload
            const filteredEnvelops = getEnvelopData(recipients, state.filterData)
            state.envelopsData = { count, envelops: recipients }
            state.filteredEnevelopData = { count: filteredEnvelops.length | 0, envelops: filteredEnvelops }
            state.envelopsLoading = false
            state.enevelopsError = null
        },
        getEnvelopsFailure(state, action: PayloadAction<any>) {
            state.enevelopsError = action.payload
            state.envelopsLoading = false
        },
        changeFilters(state, action: PayloadAction<any>) {
            const filterType = action.payload
            const newFilterData = {
                ...state.filterData,
                // eslint-disable-next-line security/detect-object-injection
                [filterType]: !state.filterData[filterType],
            }

            state.filterData = newFilterData
            const filteredEnvelops = getEnvelopData(state.envelopsData?.envelops, state.filterData)
            state.filteredEnevelopData = { count: filteredEnvelops.length | 0, envelops: filteredEnvelops }
        },
    },
})

export const { getEnvelops, getEnvelopsSuccess, getEnvelopsFailure, changeFilters } = dashboardSlice.actions
export default dashboardSlice.reducer
